import PropTypes from 'prop-types';


const IntlPropType = PropTypes.shape({
  formatMessage: PropTypes.func.isRequired,
});


export default IntlPropType;
